export default __webpack_public_path__ + "static/media/Flowers03.6160bf87.jpg";